// test2254
(2254 && 0);
